/// <reference path="../../tools/typings/angularjs/angular.d.ts"/>

angular.module('dealerware.layout',[]);

namespace Dealerware {
    export namespace Layout {
        "use strict";

        export var getDealerwareLayoutModule: () => ng.IModule = () => {
            return angular.module("dealerware.layout");
        }

        export interface IDealerwareLayoutDelegate {

            // Properties
            // ----------------------------------------

            configSectionKey        :   string;
            configLayoutClassKey    :   string;
            layoutClass             :   string;

            // Methods
            // ----------------------------------------
            getLayoutClassFromCurrentState()                    : string;
            getLayoutClass()                                    : string;
            setLayoutClass(classname : string,state? : boolean) : void;
            setLayoutClassInCurrentState(classname : string)    : void;

        }

        export class DealerwareLayoutDelegate implements IDealerwareLayoutDelegate {

            // properties
            // ------------------------------
            public configSectionKey     :   string;
            public configLayoutClassKey :   string;
            public layoutClass          :   string;

            public static $inject: string[] = ['$state','$mobilityCurrentStateDelegate'];

            // constructor
            // ------------------------------
            constructor(public $state : any,public $mobilityCurrentStateDelegate : any) {
                this.configSectionKey       = '';
                this.configLayoutClassKey   = 'layoutClass';
            }

            // methods
            // ------------------------------

            public getLayoutClassFromCurrentState() : string {
                return this.layoutClass = this.$mobilityCurrentStateDelegate.getConfigSectionValue(this.configSectionKey,this.configLayoutClassKey);
            }

            public getLayoutClass() : string {
                return (this.layoutClass || this.getLayoutClassFromCurrentState());
            }

            public setLayoutClass(classname : string, state : boolean = false)  : void {
                this.layoutClass = classname;
                if (state) {
                    this.setLayoutClassInCurrentState(classname);
                }
            }

            public setLayoutClassInCurrentState(classname : string)    : void {
                this.$mobilityCurrentStateDelegate.setConfigSectionValue(this.configSectionKey,this.configLayoutClassKey,classname);
            }

        }

        getDealerwareLayoutModule().service('$dealerwareLayoutDelegate',DealerwareLayoutDelegate);

        export interface IDealerwareLayoutController {

            //-------------------
            // properties
            //-------------------
            layoutService       :   IDealerwareLayoutDelegate;
            $rootScope          :   any;
            $scope              :   any;
            $timeout            :   any;
            registeredEvents    :   any[];


            //-------------------
            // methods
            //-------------------
            registerEvents()        :   void;
            unregisterEvents()      :   void;
            $destroy()              :   void;
            stateChangeSuccess()    :   void;

        }

        export class DealerwareLayoutController implements IDealerwareLayoutController {

            // properties
            // ---------------------------------------------------

            public registeredEvents :   any[];

            public static inject    :   string[]    =   ['$DealerwareLayoutDelegate','$rootScope','$scope','$timeout'];

            // constructor
            // --------------------------------------------------

            constructor(public layoutService : IDealerwareLayoutDelegate,public $rootScope : any,public $scope : any,public $timeout : any) {
                var _self               =   this;
                this.registeredEvents   =   [];
                this.registerEvents();
                this.$timeout(function() {
                    _self.layoutService.getLayoutClass();
                },0);
            }

            // methods
            // --------------------------------------------------

            public registerEvents() : void {

                var _self = this;

                _self.$scope.$on('$destroy',function() {_self.$destroy()});

            }

            public unregisterEvents() : void {
                this.registeredEvents.forEach(function(val) {
                    if (val && angular.isFunction(val)) {
                        val();
                    }
                });
            }

            public stateChangeSuccess() : void {}

            public $destroy()   :   void {
                this.unregisterEvents();
            }

        }

        getDealerwareLayoutModule().controller('$dealerwareLayoutController',DealerwareLayoutController);
    }
}